<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <sidebar-fixed-toggle-button />
    <side-bar
      :background-color="sidebarBackground"
      :short-title="$t('checklist.sidebar.shortTitle')"
      :logo="$store.getters.systemLogoSidebar"
      :titleImg="$store.getters.systemTitleImage"
      :title="$store.getters.systemTile"
    >
      <template slot="links">
        <!-- slot-scope="props" -->
        <sidebar-item
          v-if="isUserFormCreator"
          :link="{
            name: $t('sidebar.dashboard'),
            icon: 'tim-icons icon-chart-pie-36',
            path: '/checklist/dashboard/default',
          }"
        />
        <sidebar-item
          ref="sidebarItemForms"
          :link="{
            name: $t('checklist.sidebar.Forms'),
            icon: 'tim-icons icon-notes',
          }"
        >
          <sidebar-item
            v-if="isUserFormCreator"
            :link="{
              name: $t('checklist.sidebar.Create'),
              path: '/checklist/Layout/form/Create/',
              icon: 'tim-icons icon-upload',
            }"
          />
          <sidebar-item
            v-if="isUserFormCreator || isUserFormFiller"
            :link="{
              name: $t('checklist.sidebar.Own'),
              path: '/checklist/Layout/form/Own/',
              icon: 'tim-icons icon-upload',
            }"
          />
          <!-- <sidebar-item :link="{ name: $t('checklist.sidebar.Shared'), path: '/checklist/Layout/form/Shared/', icon: 'tim-icons icon-upload' }" /> -->
          <sidebar-item
            :link="{
              name: $t('checklist.sidebar.Filled'),
              path: '/checklist/Layout/form/Filled/',
              icon: 'tim-icons icon-upload',
            }"
          />
          <sidebar-item
            v-if="isUserFormFiller"
            :link="{
              name: $t('checklist.sidebar.Draft'),
              path: '/checklist/Layout/form/Draft/',
              icon: 'tim-icons icon-upload',
            }"
          />
        </sidebar-item>
        <!-- <sidebar-item v-if="isUserPendenciesViewer" :link="{ name: $t('checklist.sidebar.Pendencies'), path: '/checklist/Layout/form/Pendencies/', icon: 'tim-icons icon-alert-circle-exc'}" /> -->
        <sidebar-item
          v-if="isUserPendenciesViewer"
          ref="sidebarItemPendencies"
          :link="{
            name: $t('checklist.sidebar.Pendencies'),
            icon: 'tim-icons icon-alert-circle-exc',
          }"
        >
          <sidebar-item
            :link="{
              name: $t('checklist.sidebar.pendenciesOpened'),
              path: '/checklist/pendencies/opened/',
              icon: 'tim-icons icon-alert-circle-exc',
            }"
          />
          <sidebar-item
            :link="{
              name: $t('checklist.sidebar.pendenciesApproved'),
              path: '/checklist/pendencies/approved/',
              icon: 'tim-icons icon-alert-circle-exc',
            }"
          />
          <sidebar-item
            :link="{
              name: $t('checklist.sidebar.pendenciesDisapproved'),
              path: '/checklist/pendencies/disapproved/',
              icon: 'tim-icons icon-alert-circle-exc',
            }"
          />
          <sidebar-item
            :link="{
              name: $t('checklist.sidebar.pendenciesExpired'),
              path: '/checklist/pendencies/expired/',
              icon: 'tim-icons icon-alert-circle-exc',
            }"
          />
        </sidebar-item>
        <sidebar-item
          v-if="$store.getters.isAdminRms == true"
          :link="{
            name: 'Clonar formulário',
            path: '/checklist/cloningForm',
            icon: 'tim-icons icon-single-copy-04',
          }"
        ></sidebar-item>

        <sidebar-item
          v-if="$store.getters.isAdminRms == true"
          :link="{
            name: 'Scripts',
            path: '/checklist/predefinedScript/list',
            icon: 'tim-icons icon-caps-small',
          }"
        ></sidebar-item>

        <sidebar-item
          v-if="isAccessVehicles"
          ref="sidebarItemVehicle"
          :link="{
            name: 'Equipamentos',
            icon: 'tim-icons icon-delivery-fast',
          }"
        >
          <sidebar-item
            :link="{
              name: 'Equipamentos',
              path: '/checklist/vehicleRegistration/list',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Marca do Equipamento',
              path: '/checklist/brandVehicle/list',
            }"
          />
          <sidebar-item
            :link="{
              name: 'Modelo do Equipamento',
              path: '/checklist/vehicleModel/list',
            }"
          />
          <sidebar-item
            :link="{
              name: 'Tipo do Equipamento',
              path: '/checklist/vehicleType/list',
            }"
          />
          <sidebar-item
            :link="{
              name: 'Ativar/Desativar',
              path: '/checklist/vehicleAvailableReason/list',
            }"
          />
        </sidebar-item>

        <!-- Manutenções -->
        <sidebar-item
          v-if="$store.getters.accessRevisionMenu"
          ref="sidebarRevisions"
          :link="{
            name: 'Manutenções',
            icon: 'tim-icons icon-settings',
          }"
        >
          <sidebar-item
            v-if="$store.getters.accessRevisionDashboard"
            :link="{
              name: 'Painel Manutenções',
              path: '/checklist/reviewDashboard',
            }"
          />
          <sidebar-item
            v-if="$store.getters.accessRevision"
            :link="{
              name: 'Entradas de Manutenções',
              path: '/checklist/vehicleRevisionEntry/list',
            }"
          />
          <sidebar-item
            v-if="$store.getters.accessRevision"
            :link="{
              name: 'Saída de Manutenções',
              path: '/checklist/vehicleRevisionExit/list',
            }"
          />
          <!-- <sidebar-item
            :link="{
              name: 'Revisões Realizadas',
              path: '/checklist/vehicleRevisionDone/list',
            }"
          /> -->
          <sidebar-item
            v-if="$store.getters.accessRevisionIndex"
            :link="{
              name: 'Valores de Índice',
              path: '/checklist/vehicleRevision/indiceValues',
            }"
          />
        </sidebar-item>

        <!-- Abastecimentos -->
        <sidebar-item
          v-if="$store.getters.accessFuelSupplyMenu"
          ref="sidebarFuelSupply"
          :link="{
            name: $t('fuelSupply.sidebarMain'),
            materialIcon: 'local_gas_station',
          }"
        >
          <sidebar-item
            v-if="$store.getters.accessFuelSupplyDashboard"
            :link="{
              name: 'Painel de Abastecimentos',
              path: '/checklist/fuelSupplyDashboard',
              icon: 'tim-icons icon-alert-circle-exc',
            }"
          />

          <sidebar-item
            v-if="$store.getters.accessFuelSupplyDashboardHorimeter"
            :link="{
              name: 'Painel de Abastecimentos Horimetro',
              path: '/checklist/fuelSupplyDashboardHorimetro',
              icon: 'tim-icons icon-alert-circle-exc',
            }"
          />

          <sidebar-item
            v-if="$store.getters.accessFuelSupply"
            :link="{
              name: 'Registros de Abastecimentos',
              path: '/checklist/fuelSupply/list',
              icon: 'tim-icons icon-alert-circle-exc',
            }"
          />

          <sidebar-item
            v-if="$store.getters.accessFuelConsumptionTarget"
            :link="{
              name: $t('fuelConsumptionTarget.sidebar'),
              path: '/checklist/fuelConsumptionTarget/list',
              icon: 'tim-icons icon-alert-circle-exc',
            }"
          />

          <sidebar-item
            v-if="$store.getters.accessFuelStock"
            :link="{
              name: $t('fuelStock.sidebar'),
              path: '/checklist/fuelStock/list',
              icon: 'tim-icons icon-alert-circle-exc',
            }"
          />

          <sidebar-item
            v-if="$store.getters.accessGasStation"
            :link="{
              name: $t('gasStation.sidebar'),
              path: '/checklist/gasStation/list',
              icon: 'tim-icons icon-alert-circle-exc',
            }"
          />
          <sidebar-item
            v-if="$store.getters.isAdminRms == true"
            :link="{
              name: 'Importação de Abastecimentos',
              path: '/checklist/fuelSupply/import',
              icon: 'tim-icons icon-alert-circle-exc',
            }"
          />
        </sidebar-item>

        <!-- <sidebar-item
          :link="{
            name: 'Despesas',
            materialIcon: 'attach_money',
          }"
        >
          <sidebar-item
            :link="{
              name: 'Registro de Despesas',
              path: '/checklist/expense/list',
            }"
          />
        </sidebar-item>

        <sidebar-item
          :link="{
            name: 'Rotas',
            path: '/checklist/route/list',
            icon: 'tim-icons icon-square-pin',
          }"
        ></sidebar-item> -->

        <sidebar-item
          v-if="isUserViewer"
          :link="{
            name: $t('sidebar.usuarios'),
            path: '/checklist/user/list',
            icon: 'tim-icons icon-single-02',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="isProfileViewer"
          :link="{
            name: $t('system.profile.sidebar'),
            path: '/checklist/profile/all',
            icon: 'tim-icons icon-single-02',
          }"
        ></sidebar-item>

        <sidebar-item
          :link="{
            name: $t('sidebar.sector'),
            path: '/checklist/sector/all',
            icon: 'tim-icons icon-vector',
          }"
        />

        <sidebar-item
          v-if="isMasterAdmin"
          :link="{
            name: $t('system.module.sidebar'),
            path: '/checklist/module/all',
            icon: 'tim-icons icon-components',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="
            $store.getters.isAdminRms == true ||
            $store.getters.companyId == 1 ||
            $store.getters.companyId == 177
          "
          :link="{
            name: $t('sidebar.empresas'),
            path: '/checklist/company/list',
            icon: 'tim-icons icon-bank',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="
            $store.getters.companyId == 1 || $store.getters.companyId == 177
          "
          :link="{
            name: 'Financeiro',
            materialIcon: 'attach_money',
          }"
        >
          <sidebar-item
            :link="{
              name: $t('sidebar.plans'),
              path: '/checklist/plans/list',
            }"
          />
          <sidebar-item
            :link="{
              name: $t('sidebar.voucher'),
              path: '/checklist/voucher/list',
            }"
          />
        </sidebar-item>
        <sidebar-item
          v-if="$store.getters.isAdminRms == true || isAccessVehicles == true"
          :link="{
            name: $t('sidebar.costCenterTitle'),
            path: '/checklist/costCenter/list',
            icon: 'tim-icons icon-money-coins',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="$store.getters.isAdminRms == true"
          :link="{
            name: $t('system.systemIntegration.sidebar'),
            path: '/checklist/systemIntegration/all',
            icon: 'tim-icons icon-single-02',
          }"
        ></sidebar-item>
        <!-- <sidebar-item :link="{ name: $t('system.systemFieldType.sidebar'), path: '/checklist/systemFieldType/all', icon: 'tim-icons icon-single-02' }"></sidebar-item>      -->

        <sidebar-item
          v-if="isUserFormFiller"
          ref="sidebarItemSchedules"
          :link="{
            name: $t('scheduler.schedules'),
            icon: 'tim-icons icon-notes',
          }"
        >
          <sidebar-item
            v-if="isUserFormCreator"
            :link="{
              name: $t('checklist.sidebar.Create'),
              path: '/checklist/scheduler/forms',
              icon: 'tim-icons icon-upload',
            }"
          />
          <sidebar-item
            v-if="isUserFormCreator"
            :link="{
              name: $t('scheduler.schedules'),
              path: '/checklist/schedules/',
              icon: 'tim-icons icon-single-02',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('geral.pending'),
              path: '/checklist/pending/',
              icon: 'tim-icons icon-upload',
            }"
          />
          <sidebar-item
            :link="{
              name: $t('geral.typing'),
              path: '/checklist/typing/',
              icon: 'tim-icons icon-upload',
            }"
          />
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar module="checklist"></dashboard-navbar>
      <router-view name="header"></router-view>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
//import SidebarShare from "./SidebarSharePlugin";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "@/pages/Layout/DashboardNavbar.vue";
import ContentFooter from "../../../pages/Layout/ContentFooter.vue";
import SidebarFixedToggleButton from "../../../pages/Layout/SidebarFixedToggleButton.vue";
import { ZoomCenterTransition } from "vue2-transitions";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
    ZoomCenterTransition,
  },

  data() {
    return {
      sidebarBackground: "primary", //vue|blue|orange|green|red|primary
      isMasterAdmin: false,
    };
  },
  created() {
    this.getUserMaster();
  },
  computed: {
    isUserAdmin() {
      return this.$store.getters.isAdministrator;
    },
    isUserFormCreator() {
      return this.$store.getters.isChecklistFormCreator;
    },
    isUserFormFiller() {
      return this.$store.getters.isChecklistFormFiller;
    },
    isUserPendenciesViewer() {
      return this.$store.getters.isChecklistPendenciesView;
    },
    isUserViewer() {
      return this.$store.getters.hasAccessUser;
    },
    isProfileViewer() {
      return this.$store.getters.hasAccessProfile;
    },
    isCompanyViewer() {
      return this.$store.getters.hasAccessCompany;
    },
    isAccessVehicles() {
      return this.$store.getters.accessVehicles;
    },
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar("sidebar");
        //initScrollbar("main-panel");
        initScrollbar("sidebar-wrapper");

        docClasses.add("perfect-scrollbar-off"); // docClasses.add("perfect-scrollbar-on");
      } else {
        docClasses.add("perfect-scrollbar-off");
      }
    },
    getUserMaster() {
      this.$apiScheduler
        .get("/module/getUserMaster/")
        .then((response) => {
          this.isMasterAdmin = response.data;
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
  },
  mounted() {
    this.initScrollbar();
    // if (this.$refs.sidebarItemForms) {
    //   if (this.$refs.sidebarItemForms.collapsed) {
    //     this.$refs.sidebarItemForms.collapseMenu();
    //   }
    // }
    // if (this.$refs.sidebarItemPendencies) {
    //   if (this.$refs.sidebarItemPendencies.collapsed) {
    //     this.$refs.sidebarItemPendencies.collapseMenu();
    //   }
    // }
    // if (this.$refs.sidebarItemSchedules) {
    //   if (this.$refs.sidebarItemSchedules.collapsed) {
    //     this.$refs.sidebarItemSchedules.collapseMenu();
    //   }
    // }
  },
};
</script>

<style lang="scss">
$scaleSize: 0.95;

@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
/* example */
.ps {
  height: 100%;
}
</style>
